import ListItemLoading from "@/components/loading/listItemLoading/listItemLoading";
import { SmsGroupTemplateType, SmsTemplateStatus } from "@/models/club";
import PageHeader from "@/modules/smsLibrary/PageHeader";
import TemplateForm from "@/modules/smsLibrary/TemplateForm";
import { stripOptOut } from "@/modules/smsLibrary/sms";
import classes from "@/modules/smsLibrary/sms.module.scss";
import { SmsTemplate } from "@/services/discount/type";
import useUpdateTemplate from "@/services/template/hooks/useUpdateTemplate";
import { notifications } from "@mantine/notifications";
import { IconAlertTriangle, IconInfoCircle } from "@tabler/icons-react";
import { useQueryClient } from "@tanstack/react-query";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useGetSmsTemplates from "../../../messages/hooks/useGetSmsTemplates";

function EditTemplate() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useUpdateTemplate();
  const fromState = (useLocation().state as { template?: SmsTemplate } | null)?.template;
  const [params] = useSearchParams();
  const id = Number(params.get("id") ?? fromState?.id ?? 0);
  // The id in the address keeps the page working after a refresh, when router state is gone.
  const list = useGetSmsTemplates(SmsGroupTemplateType.Value4);
  const template = fromState?.id === id ? fromState : (list.data ?? []).flatMap((g) => g.templates ?? []).find((t) => t.id === id);

  const banner =
    template?.status === SmsTemplateStatus.Value2 ? (
      <div className={classes.notice} data-tone="danger" role="status">
        <IconAlertTriangle size={20} stroke={1.8} aria-hidden />
        <span className={classes.noticeText}>
          <strong style={{ fontSize: 14 }}>این قالب رد شد</strong>
          <span>{template.adminMessage || "دلیلی ثبت نشده است."}</span>
          <span style={{ fontSize: 12 }}>متن را اصلاح کنید و دوباره برای بررسی بفرستید.</span>
        </span>
      </div>
    ) : template?.status === SmsTemplateStatus.Value1 ? (
      <div className={classes.notice} data-tone="warning">
        <IconInfoCircle size={19} stroke={1.8} aria-hidden />
        <span>این قالب تأیید شده است. با ذخیره‌ی تغییرات، تا تأیید دوباره در ارسال‌ها نمایش داده نمی‌شود. برای نگه‌داشتن نسخه‌ی فعلی، از «ساخت نسخه‌ی کپی» استفاده کنید.</span>
      </div>
    ) : undefined;

  return (
    <div className={classes.page}>
      <PageHeader title="ویرایش قالب" back="/dashboard/profile/template" />
      {template ? (
        <TemplateForm
          key={template.id}
          initialTitle={template.title ?? ""}
          initialText={stripOptOut(template.text)}
          banner={banner}
          collapseVariables
          submitLabel={template.status === SmsTemplateStatus.Value2 ? "ارسال دوباره برای بررسی" : "ذخیره و ارسال برای بررسی"}
          loading={isLoading}
          onSubmit={(values) =>
            mutate(
              { id: template.id, ...values },
              {
                onSuccess() {
                  notifications.show({ color: "green", message: "تغییرات ذخیره شد و قالب برای بررسی فرستاده شد" });
                  queryClient.invalidateQueries({ queryKey: ["allSmsTemplate"] });
                  navigate("/dashboard/profile/template", { replace: true });
                },
              },
            )
          }
        />
      ) : (
        <div className={classes.body}>{list.isLoading ? <ListItemLoading count={2} /> : <div className={classes.empty}>این قالب پیدا نشد؛ شاید حذف شده باشد.</div>}</div>
      )}
    </div>
  );
}

export default EditTemplate;
